import { AxiosError } from 'axios';

import { ZEE_PERSONA_DATA_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZeePersonaData } from '@/types/zee-persona-data.type';

export type GetZeePersonaDataApiResponse = {
  persona_data: ZeePersonaData;
};

export const getZeePersonaData = async (
  userId: string
): Promise<ApiResponse<GetZeePersonaDataApiResponse>> => {
  try {
    const response = await apiManager.get(
      `${ZEE_PERSONA_DATA_API_URL}/${userId}`,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
